import React, { useEffect, useState, useCallback } from "react";
import { Link, useLocation } from "react-router-dom";
import ThemeToggle from "../../common/ThemeToggle/ThemeToggle";
import AuthMenu from "../../common/AuthMenu/AuthMenu";
import InviteStatusBanner from "../../common/InviteStatusBanner/InviteStatusBanner"; // toast; fixed
import styles from "./MarketingNavbar.module.css";
import { useAuth } from "../../../context/AuthContext";

export default function MarketingNavbar() {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    setIsCollapsed(true);
  }, [location]);

  const handleNavClick = useCallback(() => setIsCollapsed(true), []);

  useEffect(() => {
    const handler = () => setIsCollapsed(true);
    window.addEventListener("hashchange", handler);
    return () => window.removeEventListener("hashchange", handler);
  }, []);

  return (
    <>
      {/* Skip link for keyboard users */}
      <a href="#main" className="visually-hidden-focusable">
        Skip to main content
      </a>

      <header className={`sticky-top border-bottom ${styles.header}`}>
        <nav
          className="navbar navbar-expand-lg bg-body-tertiary"
          aria-label="Main navigation"
          role="navigation"
        >
          <div className="container">
            <Link
              className={`navbar-brand d-flex align-items-center ${styles.brand}`}
              to="/"
              aria-label="Pocket Penny — Home"
              onClick={handleNavClick}
            >
              <img
                src="/pp-logo.png"
                alt="Pocket Penny"
                className={styles.logoImg}
                height={28}
                width={28}
              />
              <span className="fw-bold">Pocket&nbsp;Penny</span>
              <span className={`ms-2 ${styles.betaBadge}`} aria-label="Public Beta">
              Public Beta
              </span>
            </Link>

            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#pp-navbar"
              aria-controls="pp-navbar"
              aria-expanded={!isCollapsed}
              aria-label="Toggle navigation"
              onClick={() => setIsCollapsed((v) => !v)}
            >
              <span className="navbar-toggler-icon" />
            </button>

            <div
              id="pp-navbar"
              className={`collapse navbar-collapse ${!isCollapsed ? "show" : ""}`}
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0" onClick={handleNavClick}>
                <li className="nav-item">
                  <a className="nav-link" href="#about">
                    About
                  </a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="#features">
                    Features
                  </a>
                </li>
                {/* <li className="nav-item">
                  <a className="nav-link" href="#demo">
                    Request Invite
                  </a>
                </li> */}
                <li className="nav-item">
                  <Link className="nav-link" to="/privacy">
                    Privacy
                  </Link>
                </li>
                <li className="nav-item">
                  <Link className="nav-link" to="/terms">
                    Terms
                  </Link>
                </li>
              </ul>

              <div className="d-flex align-items-center gap-2">
                {user ? (
                  <AuthMenu variant="nav" />
                ) : (
                  <Link className={`btn btnSignIn btn-sm`} to="/auth">
                    Sign in
                  </Link>
                )}
                <ThemeToggle />
              </div>
            </div>
          </div>
        </nav>
      </header>

      {/* Toast lives fixed in the corner; doesn't affect navbar height */}
      <InviteStatusBanner />
    </>
  );
}
